export const toVoidFunction = <T extends unknown[], R>(
  fn: (...args: T) => Promise<R>,
) => {
  return (...args: T): void => {
    fn(...args)
  }
}
